import { useRef } from 'react';
import { useInitialResults } from '../../hooks/useInitialResults';
import { useCalculatedHeight } from '../../hooks/useCalculatedHeight';
import SkeletonCardItems from './skeletonCardItems';
import './skeletonLoader.sass';

const GAP = 10;
const PADDING = 30;
const BUTTON_HEIGHT = 50;

/**
 * Skeleton loader para las notas del panel derecho.
 * Versión simplificada del SkeletonLoader principal, sin el summary.
 * 
 * @param {Object} props
 * @param {number} [props.count=3] - Número de skeleton cards a mostrar
 */
export default function NotesSkeletonLoader({ count = 3 }) {
  const gridRef = useRef(null);
  const INITIAL_RESULTS = useInitialResults();

  const calculatedMaxHeight = useCalculatedHeight(gridRef, INITIAL_RESULTS, {
    gap: GAP,
    padding: PADDING,
    extraHeight: BUTTON_HEIGHT,
  });

  return (
    <section
      className="list-wrapper-results skeleton-container any-padding"
      style={{ 
        maxHeight: calculatedMaxHeight ? `${calculatedMaxHeight}px` : 'auto', 
        overflow: 'hidden' 
      }}
    >
      <div
        ref={gridRef}
        id="resultadosUTV"
        className="skeleton-results skeleton-grid skeleton-border"
      >
        {/* <div className="skeleton-line skeleton-line-title-grid shortTitle"></div> */}
        <SkeletonCardItems count={count} />
      </div>
    </section>
  );
}
